@if (isUpdating$ | async) {
  <cx-spinner class="overlay"></cx-spinner>
}

<div class="row header-container">
  <div class="col-12">
    <h1 class="page-title">{{pageTitle}}</h1>
    <p class="description">{{pageDescription}}</p>
  </div>
</div>

<div class="row">
  <div class="col-12 form-group">
    <div class="form-control bg-light-grey border-0">
      <label>
        <span
        class="label-content">{{'updateProfileForm.emailAddress.label' | cxTranslate }}</span> {{(user$ | async)?.uid}}
      </label>
    </div>
  </div>
</div>


<form [formGroup]="form">
  @if (isProfessional()) {
    <div class="row">
      <div class="col-md-6">
        <div class="form-group ">
          <label>
            <span class="label-content mandatory">{{'updateProfileForm.firstNameProf.label' | cxTranslate}}</span>
            <input
              type="text"
              class="form-control"
              name="firstName"
              placeholder="{{'updateProfileForm.firstNameProf.placeholder' | cxTranslate}}"
              formControlName="firstName"
              maxlength="70"
              />
            <cx-form-errors [control]="form.get('firstName')"></cx-form-errors>
          </label>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>
            <span class="label-content">{{'updateProfileForm.contactPerson.label' | cxTranslate}}</span>
            <input
              type="text"
              class="form-control"
              name="contactPerson"
              placeholder="{{'updateProfileForm.contactPerson.placeholder' | cxTranslate}}"
              formControlName="contactPerson"
              maxlength="35"
              />
            <cx-form-errors [control]="form.get('contactPerson')"></cx-form-errors>
          </label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group" formGroupName="jobType">
          <label class="select-label">
            <span class="label-content mandatory">{{'register.jobType' | cxTranslate}}</span>
            @if (jobTypes$ | async; as jobs) {
              <div>
                <select formControlName="code" class="form-control">
                  <option selected value="" disabled>
                    {{ 'register.jobType' | cxTranslate }}
                  </option>
                  @for (job of jobs; track job) {
                    <option  [value]="job.code" >
                      {{ job.name }}
                    </option>
                  }
                </select>
                <app-custom-icons [type]="iconTypes.ARROW_DOWN_ICON"></app-custom-icons>
              </div>
            }
            <!--            <ng-container *ngIf="jobTypes$ | async as jobs">-->
            <!--              <ng-select-->
            <!--                formControlName="code"-->
            <!--                [searchable]="true"-->
            <!--                [clearable]="false"-->
            <!--                [items]="jobs"-->
            <!--                bindLabel="name"-->
            <!--                bindValue="code"-->
          <!--              ></ng-select>-->
        <!--            </ng-container>-->
        <cx-form-errors [control]="form.get('jobType.code')"></cx-form-errors>
      </label>
    </div>
  </div>
</div>
} @else {
  <div class="form-group row">
    <div class="col-md-12">
      <label>
        <span class="label-content mandatory">{{'updateProfileForm.firstName.label' | cxTranslate}}</span>
        <input
          type="text"
          class="form-control"
          name="firstName"
          placeholder="{{'updateProfileForm.firstName.placeholder' | cxTranslate}}"
          formControlName="firstName"
          maxlength="70"
          />
        <cx-form-errors [control]="form.get('firstName')"></cx-form-errors>
      </label>
    </div>
  </div>
}
<div class="row">
  <div class="col-md-6">
    <div class="form-group">
      <label>
        <span class="label-content mandatory">{{'updateProfileForm.mobilePhone.label' | cxTranslate}}</span>
        <input
          class="form-control"
          type="text"
          name="mobilePhone"
          placeholder="{{'updateProfileForm.mobilePhone.placeholder' | cxTranslate}}"
          formControlName="mobilePhone"
          />
        <cx-form-errors [control]="form.get('mobilePhone')"></cx-form-errors>
      </label>
    </div>
  </div>

  <div class="col-md-6">
    <div class="form-group">
      <label>
        <span class="label-content">{{'updateProfileForm.birthday.label' | cxTranslate}}</span>
        <app-date-picker
          [control]="form.get('birthday')"
          (update)="updateDatepicker('birthday')"
        ></app-date-picker>
        <cx-form-errors [control]="form.get('birthday')"></cx-form-errors>
      </label>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-md-6">

    <div class="form-group">
      <label>
        <span class="label-content">{{'updateProfileForm.dni' | cxTranslate}}</span>
        <input
          class="form-control"
          type="text"
          name="documentIdentifier"
          formControlName="documentIdentifier"
          />
        <cx-form-errors [control]="form.get('documentIdentifier')"></cx-form-errors>
      </label>
    </div>

  </div>
  @if (professional) {
    <div class="col-md-6">
      <div class="form-group">
        <label>
          <span class="label-content">{{'updateProfileForm.userTaxGroup' | cxTranslate}}</span>
          <input
            class="form-control"
            type="text"
            name="userTaxGroup"
            formControlName="userTaxGroup"
            [readOnly]="true"
            />
          <cx-form-errors [control]="form.get('userTaxGroup')"></cx-form-errors>
        </label>
      </div>
    </div>
  }

</div>
<ng-container formGroupName="defaultBillingAddress">
  <div class="row">
    <div class="col-md-12">
      <div class="form-group">
        <label>
          @if (isProfessional()) {
            <span class="label-content mandatory">{{'updateProfileForm.line1Prof.label' | cxTranslate}}</span>
          } @else {
            <span class="label-content mandatory">{{'updateProfileForm.line1.label' | cxTranslate}}</span>
          }
          <input
            class="form-control"
            type="text"
            name="line1"
            placeholder="{{ 'updateProfileForm.line1.placeholder' | cxTranslate}}"
            formControlName="line1"
            maxlength="70"
            />
          <cx-form-errors [control]="form.get('defaultBillingAddress.line1')"></cx-form-errors>
        </label>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-6">
      <div class="form-group">
        <label>
          <span class="label-content mandatory">{{'updateProfileForm.postalCode.label' | cxTranslate}}</span>
          <input
            class="form-control"
            type="text"
            name="postalCode"
            placeholder="{{'updateProfileForm.postalCode.placeholder' | cxTranslate}}"
            formControlName="postalCode"
            (keypress)="validatePostalCode()" (focusout)="validatePostalCode()"/>
          <cx-form-errors [control]="form.get('defaultBillingAddress.postalCode')"></cx-form-errors>
        </label>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group">
        <label>
          <span class="label-content mandatory">{{'updateProfileForm.town.label' | cxTranslate}}</span>
          <input
            class="form-control"
            type="text"
            name="town"
            placeholder="{{'updateProfileForm.town.placeholder' | cxTranslate}}"
            formControlName="town"
            maxlength="35"
            />
          <cx-form-errors [control]="form.get('defaultBillingAddress.town')"></cx-form-errors>
        </label>
      </div>
    </div>
  </div>
  <div class="row">

    <div class="col-md-6" formGroupName="country">
      <label class="select-label">
        <span class="label-content mandatory">{{'updateProfileForm.country.label' | cxTranslate}}</span>
        @if (countries$ | async; as countries) {
          <div>
            <select formControlName="isocode" class="form-control" readonly="true" disabled>
              <option selected value="">
                {{ 'updateProfileForm.country.label' | cxTranslate }}
              </option>
              @for (country of countries; track country) {
                <option class="option-select" [value]="country.isocode" >
                  {{ country.name }}
                </option>
              }
            </select>
            <app-custom-icons [type]="iconTypes.ARROW_DOWN_ICON"></app-custom-icons>
          </div>
        }

        <!--          <ng-container *ngIf="countries$ | async as countries">-->
        <!--            <ng-select-->
        <!--              formControlName="isocode"-->
        <!--              [searchable]="true"-->
        <!--              [clearable]="false"-->
        <!--              [items]="countries"-->
        <!--              bindLabel="name"-->
        <!--              bindValue="isocode"-->
        <!--              [readonly]="true"-->
      <!--            ></ng-select>-->
    <!--          </ng-container>-->

    <cx-form-errors [control]="form.get('defaultBillingAddress.country.isocode')"></cx-form-errors>
  </label>

</div>

<div class="col-md-6 mb-3">
  <div class="form-group" formGroupName="region">
    <label class="select-label">
      <span class="label-content mandatory">{{'updateProfileForm.region.label' | cxTranslate}}</span>
      @if (regions$ | async; as regions) {
        <div>
          <select formControlName="isocode" class="form-control" (change)="validatePostalCode()">
            <option selected value="">
              {{ 'updateProfileForm.region.label' | cxTranslate }}
            </option>
            @for (region of regions; track region) {
              <option class="option-select" [value]="region.isocode" >
                {{ region.name }}
              </option>
            }
          </select>
          <app-custom-icons [type]="iconTypes.ARROW_DOWN_ICON"></app-custom-icons>
        </div>
      }

      <!--            <ng-container *ngIf="regions$ | async as regions">-->
      <!--              <ng-select-->
      <!--                formControlName="isocode"-->
      <!--                [searchable]="true"-->
      <!--                [clearable]="false"-->
      <!--                [items]="regions"-->
      <!--                bindLabel="name"-->
      <!--                (change)="validatePostalCode()"-->
      <!--                bindValue="isocode"-->
    <!--              ></ng-select>-->
  <!--            </ng-container>-->

  <cx-form-errors
    [control]="form.get('defaultBillingAddress.region.isocode')"
  ></cx-form-errors>
</label>
</div>
</div>
</div>
</ng-container>
<div class="form-group row">
  <div class="col-lg-4 mt-4">
    <button class="btn  btn-block btn-black" type="button" (click)="isValidateTaxIdentification()">
      {{ 'common.update' | cxTranslate }}
    </button>
  </div>
</div>
</form>

<hr class="mt-4 mb-4"/>

